import React from "react";
import Navbar from "../reusable/navbar";
import Style from "./ticketsDetails.module.scss";
import { useTranslation } from "react-i18next";
import SuccessIcon from "../common/assets/success-icon.svg";

const CancelledTicketDetails = () => {
  const { t } = useTranslation();

  return (
    <div className={Style.mainContainerDesktop}>
      <Navbar />
      <div className={Style.formResponsive}>
        <h3 className={Style.formResponsive__subtitle}>
          {t("TicketDetails.TicketCancelled")}
        </h3>

        <div className={Style.formResponsive__content}>
          <img
            src={SuccessIcon}
            alt="success"
            className={Style.successIcon}
          />
          <p className={Style.formResponsive__paragraph}>
            {t("TicketDetails.TicketHasBeenCancelled")}
          </p>
          <p className={Style.formResponsive__paragraph}>
            {t("TicketDetails.No further action is required.")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CancelledTicketDetails;
